import {useMemo} from 'react';
import {TableCustomCell} from '../../../../component/table/components/TableCustomCell';
import {TableCustomHeader} from '../../../../component/table/components/TableCustomHeader';
import {TableCustom} from '../../../../component/table/table-custom/TableCustom';
import {formatTrangThaiBenhNhan} from '../../../../utils/FormatUtils';

type Props = {
  data: any[];
  onItemSelect?: (data: any) => void;
  selectedRow: any;
};

const DanhSachPhieu = ({data, onItemSelect, selectedRow}: Props) => {
  const COLUMNS = useMemo(
    () => [
      {
        Header: (props: any) => (
          <TableCustomHeader
            tableProps={props}
            title="TT"
            className="text-center text-white px-3 min-w-30px"
          />
        ),
        id: 'STT',
        Cell: ({...props}) => (
          <TableCustomCell
            className="text-center"
            data={formatTrangThaiBenhNhan('#3C78D8')}
          />
        ),
      },
      {
        Header: (props: any) => (
          <TableCustomHeader
            tableProps={props}
            title="Thông tin phiếu"
            className="text-center text-white px-3 min-w-125px"
          />
        ),
        id: 'phieuTruyenDich',
        Cell: ({...props}) => (
          <TableCustomCell
            data={
              <div className="text-start">
                <h6 className="">
                  {props.row.original?.date || props.row.original?.inputDate}
                </h6>
                <span>{props.row.original?.description}</span>
              </div>
            }
          />
        ),
      },
    ],
    []
  );

  return (
    <div>
      <TableCustom
        columns={COLUMNS}
        data={data}
        selectionMode="singleNoRadioButton"
        getSelectedRowsData={(rows: any) => {
          onItemSelect?.(rows[0]);
        }}
        rowSelected={selectedRow}
        rowKey="id"
      />
    </div>
  );
};

export default DanhSachPhieu;
